import cookies from './BaseCookies';

const RemoveCookie = (token) => {
    cookies.remove(token);
}

export default RemoveCookie;